import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    MemberVoucherList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberVoucher/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/memberVoucher.js